import type { ChatItem } from '../../../contracts/harness.types';
import { REPORT_ISSUE_TOOL_NAME } from '../../../contracts/report-issue.types';

/**
 * The report receipt card is the whole confirmation. Drop the model's
 * follow-up text in that turn so it cannot restate a reference number.
 */
export const omitReportIssueConfirmation = (items: ChatItem[]): ChatItem[] => {
  const hasReceipt = items.some(
    (item) =>
      item.kind === 'tool_use' &&
      item.name === REPORT_ISSUE_TOOL_NAME &&
      item.status === 'complete'
  );
  if (!hasReceipt) return items;

  let receiptShown = false;
  const visible: ChatItem[] = [];
  for (const item of items) {
    if (item.kind === 'user_message') {
      receiptShown = false;
      visible.push(item);
      continue;
    }
    if (
      item.kind === 'tool_use' &&
      item.name === REPORT_ISSUE_TOOL_NAME &&
      item.status === 'complete'
    ) {
      receiptShown = true;
      visible.push(item);
      continue;
    }
    if (receiptShown && item.kind === 'assistant_text') continue;
    visible.push(item);
  }
  return visible;
};
